import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import { constants } from '../../../constants/index';
const ProgressSpinner = (props) => {
    return (
        <div style={styles.spinnerStyles}>
            <CircularProgress size={ 100 }/>
            <p style={{ textAlign: 'center', fontSize: constants.text.baseFontStyles.fontSize }}>
                PROCESSING...
            </p>
            <p style={{ textAlign: 'center', fontSize: constants.text.baseFontStyles.fontSize }}>(You will be redirected shortly. Please do not leave or close this window.)</p>
        </div>
    );
}

const styles= {
    spinnerStyles: { 
        marginBottom: -346, 
        backgroundColor: 'rgba(255,255,255,0.7)', 
        position: 'relative', 
        zIndex: 5, 
        alignSelf: 'center', 
        minHeight: '70%', 
        minWidth: '100%', 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
    },
}

export default ProgressSpinner;


// WEBPACK FOOTER //
// ./src/js/components/Form/PaymentForms/ProgressSpinner.jsx